import { render, staticRenderFns } from "./subSeccionesTabla.vue?vue&type=template&id=15886f3c"
import script from "./subSeccionesTabla.vue?vue&type=script&lang=js"
export * from "./subSeccionesTabla.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports